import { Database, Globe2 } from 'lucide-react';
import type { ToolExecutionKind } from '../../lib/api';
import styles from './LookupTool.module.css';

interface ToolTypeChooserProps {
  onSelect: (kind: ToolExecutionKind) => void;
}

export const ToolTypeChooser = ({ onSelect }: ToolTypeChooserProps) => (
  <fieldset className={styles.chooser}>
    <legend>What should this tool do?</legend>
    <p>Choose the execution type first. You can change it until the tool is saved.</p>
    <section className={styles.options}>
      <button type="button" onClick={() => onSelect('http')}>
        <Globe2 />
        <strong>Call an HTTP API</strong>
        <span>Call an external HTTPS endpoint with configured authentication and inputs.</span>
      </button>
      <button type="button" onClick={() => onSelect('schema_lookup')}>
        <Database />
        <strong>Look up synced schema data</strong>
        <span>Query synced custom-schema records for the identified customer with fixed filters.</span>
      </button>
    </section>
  </fieldset>
);
